import ImageComponent from "@/common/ImageComponent";
import useTrans from "@/hooks/useTrans";
import { useCartContext } from "@/setup/cartProvider";
import { ActionIcon, Badge, Box, Text, UnstyledButton } from "@mantine/core";
import { AiOutlineDelete } from "@react-icons/all-files/ai/AiOutlineDelete";
import { FiImage } from "@react-icons/all-files/fi/FiImage";
import { useRouter } from "next/router";
import numeral from "numeral";
import useStyles from "../../styles/CartLeftSection";
import { QuantityInput } from "../QuantityChange";

function CartItem() {
  const { classes } = useStyles();
  const context = useCartContext();
  const { locale } = useRouter();
  const trans = useTrans();
  const deleteCart = async (product) => {
    try {
      await context?.deleteCart(product);
    } catch (error) {
      console.log(error);
    }
  };
  function Item({ item }) {
    // console.log("item", item);

    const picture_url = item?.picture_tt || item?.picture;

    const gia_ban = item?.gia_ban_nt - item?.tien_ck / item.sl_xuat;
    // console.log("gia ban", gia_ban)
    return (
      <Box sx={{ display: "flex" }} key={item?._id}>
        <Box sx={{ justifyContent: "center", alignItems: "center" }}>
          {picture_url ? (
            <ImageComponent src={picture_url} width="100%" height="100%" />
          ) : (
            <FiImage size={50} />
          )}
        </Box>
        <Box
          sx={{
            flex: 1,
            flexDirection: "row",
            display: "flex",
            "@media (max-width: 500px)": {
              flexDirection: "column",
            },
          }}
        >
          <Box sx={{ flex: 4, paddingLeft: 10 }}>
            <Text className={classes.productName}>
              {item?.ten_vt
                ? locale === "vi"
                  ? item?.ten_vt
                  : item?.ten_vt_eng
                  ? item?.ten_vt_eng
                  : "..."
                : "..."}
            </Text>
            {item?.thuoc_tinh &&
              item?.thuoc_tinh?.gia_tri_bien_the_1 &&
              item?.thuoc_tinh?.gia_tri_bien_the_2 && (
                <Text className={classes.propertiesName}>
                  {item?.thuoc_tinh?.gia_tri_bien_the_1},{" "}
                  {item?.thuoc_tinh?.gia_tri_bien_the_2}
                </Text>
              )}
            {!item?.ton && (
              <Badge color="teal" size="xs">
                <Text weight="normal">{trans.cart.avail}</Text>
              </Badge>
            )}
          </Box>
          <Box
            sx={{
              flex: 2,
              display: "flex",
              flexDirection: "column",
              "@media (max-width: 500px)": {
                justifyContent: "flex-start",
                paddingLeft: 10,
              },
            }}
          >
            {gia_ban !== item?.gia_ban_nt && (
              <Text color="black">{numeral(gia_ban).format("0,0")}</Text>
            )}
            <Text
              sx={{
                fontSize: gia_ban !== item?.gia_ban_nt && 14,
              }}
              strikethrough={gia_ban !== item?.gia_ban_nt && true}
              className={classes.price}
            >
              {numeral(item?.gia_ban_nt).format("0,0")}
            </Text>
          </Box>
          <QuantityInput item={item} />
          <Box
            sx={{
              flex: 2,
              justifyContent: "center",
              display: "flex",
              "@media (max-width: 500px)": {
                justifyContent: "flex-start",
                paddingLeft: 10,
                display: "none",
              },
            }}
          >
            <Text className={classes.priceTotal}>
              {numeral(item?.tien_nt).format("0,0")}
            </Text>
          </Box>
          <Box
            sx={{
              flex: 1,
              justifyContent: "center",
              display: "flex",

              "@media (max-width: 500px)": {
                justifyContent: "flex-start",
                paddingLeft: 10,
                display: "none",
              },
            }}
          >
            <ActionIcon onClick={() => deleteCart(item)}>
              <AiOutlineDelete variant="transparent" size={22} />
            </ActionIcon>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={classes.containerMain}>
      {context?.cart?.map((item) => (
        <Item item={item} key={item?._id} />
      ))}
    </Box>
  );
}

export default CartItem;
